import { useMutation, useQuery, useQueryClient } from "react-query"
import Network from "../../network"

export default function useEditControlls() {

    const client = useQueryClient();

    const {data, isLoading} = useQuery('edit-status', Network.getPublicEditStatus);

    const {mutate: open} = useMutation(() => Network.openPublicEdit(), {
        onSuccess() {
            client.invalidateQueries('edit-status');
        }
    })

    const {mutate: close} = useMutation(() => Network.closePublicEdit(), {
        onSuccess() {
            client.invalidateQueries('edit-status');
        }
    })

    return {
        open,
        close,
        isLoading,
        status: data?.isEditOpen || false
    }
}
